<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Other In-Game Item NFTs"></springText>
    </div>
    <fadeInAnimation>
      <div class="text-list">
        <div class="text-item">
          <div class="sub-title">
            Advanced Battle Passes, Batteries, Spark, Bounty Cases, and other item NFTs can all be traded within the
            MATR1X FIRE Asset Collection. The trading process is the same as for character NFTs.
          </div>
          <div class="sub-title alink-sub">
            <div class="icon-wrap">
              <img src="@/assets/images/playDetails/marketplace/tradingLink.png" alt="">
            </div>
            Trading Link: <a target="_blank"
              href="https://www.okx.com/web3/marketplace/nft/collection/polygon/matr1x-fire-asset-collection">https://www.okx.com/web3/marketplace/nft/collection/polygon/matr1x-fire-asset-collection</a>
            <i class="el-icon-caret-right"></i>
          </div>
        </div>
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>